<script setup lang="ts">
  import { computed } from "vue";
  import { Search, X } from "lucide-vue-next";
  import { Input } from "@/components/ui/input";

  const props = withDefaults(
    defineProps<{
      modelValue?: string;
      placeholder?: string;
      size?: "default" | "sm";
      variant?: "default" | "muted";
      fullWidth?: boolean;
      clearable?: boolean;
    }>(),
    {
      modelValue: "",
      placeholder: "Search...",
      size: "default",
      variant: "default",
      fullWidth: false,
      clearable: true,
    },
  );

  const emit = defineEmits<{
    "update:modelValue": [value: string];
  }>();

  const containerClass = computed(() => (props.fullWidth ? "w-full" : "flex-1 max-w-sm"));

  const wrapperClass = computed(() => {
    if (props.variant === "muted") return "rounded-lg bg-muted text-13";
    return props.size === "sm" ? "h-7 bg-white" : "bg-white";
  });

  const iconClass = computed(() =>
    props.size === "sm" ? "h-3.5 w-3.5 text-muted-foreground" : "h-4 w-4 text-muted-foreground",
  );

  const showClear = computed(() => props.clearable && props.modelValue);

  const clearValue = () => emit("update:modelValue", "");
</script>

<template>
  <div :class="containerClass">
    <Input
      :model-value="props.modelValue"
      :placeholder="props.placeholder"
      :class="wrapperClass"
      @update:model-value="emit('update:modelValue', String($event))">
      <template #prepend>
        <Search :class="iconClass" />
      </template>
      <template
        v-if="showClear"
        #append>
        <X
          :class="[iconClass, 'cursor-pointer hover:text-foreground']"
          @click="clearValue" />
      </template>
    </Input>
  </div>
</template>
